import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import { getDataLayer, getEmbeddedErrorMessageAnalytic } from '../../../common/utilities/utils';
import events from '@kfc-global/react-shared/analytics/Register';
import { getPriceWithoutTax } from 'common/utilities/utils';
import { scroller } from 'react-scroll';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ORDER_HISTORY from 'organisms/AccountPage/Constants/Constants';
import { MENU_PLP_CONSTANT, TURNED_NO_RESULTS_TEXT, YOUR_SEARCH_TEXT } from '../MenuPLPConstants/MenuPLPConstants';
import isEmpty from 'lodash/isEmpty';
import { ANALYTICS_SHARED_CONSTANTS } from 'common/constants/SharedConstants';

/**
 * Method to set analytics items in the data layer object
 */
export const menuNavigationAnalyticsData = async (categoryName, menuIndex) => {
  await AnalyticsService.registerEvent(
    events.menuNavigation.name,
    {
      '%event%': 'menuNavigation',
      '%menuNavigationLink%': categoryName,
      '%menuIndex%': menuIndex,
    },
    getDataLayer,
  );
};
export const setAnalyticsData = async (analyticsData, field) => {
  const analyticsItems = [];
  analyticsItems.push({
    event: analyticsData.eventType,
    [field]: analyticsData.selectedData,
  });
  console.log(analyticsItems);
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

export const setAnalyticsDataSearchPlp = async (analyticsData, field1, field2) => {
  const analyticsItems = [];
  analyticsItems.push({
    event: analyticsData.eventType,
    [field1]: analyticsData.selectedData[field1],
    [field2]: analyticsData.selectedData[field2],
  });
  console.log(analyticsItems);
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

export const setAnalyticsDataFilter = async (analyticsData, field1, field2, field3) => {
  const analyticsItems = [];
  analyticsItems.push({
    event: analyticsData.eventType,
    [field1]: analyticsData.selectedData[field1],
    [field2]: analyticsData.selectedData[field2],
    [field3]: analyticsData.selectedData[field3],
  });
  console.log(analyticsItems);
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

export const filterRecommendations = (products, pastOrdersData) => {
  const dataTemp = JSON.parse(JSON.stringify(products));
  let recommendProdArr = [];
  pastOrdersData?.length &&
    pastOrdersData.forEach(obj => {
      let recommendProd = dataTemp?.find(
        ({ isHidden = false, items }) => !isHidden && items?.length && items[0].id === obj.id,
      );
      if (recommendProd) {
        recommendProdArr.push(recommendProd);
      }
    });

  return recommendProdArr;
};

export const getAnalytictsPayloadConditionaly = (
  selectedCategory,
  selectedSubcategory,
  name,
  id,
  currencyFactor,
  index,
) => {
  let productList = [];
  if (
    selectedCategory?.categories &&
    selectedCategory?.products?.length === 0 &&
    Object.keys(selectedSubcategory).length === 0
  ) {
    productList = getAnalytictsPayload(selectedCategory.categories[0], name, id, currencyFactor);
  } else if (Object.keys(selectedSubcategory).length > 0) {
    productList = getAnalytictsPayload(selectedSubcategory, name, id, currencyFactor);
  } else {
    productList = getAnalytictsPayload(selectedCategory, name, id, currencyFactor);
  }
  return productList;
};
export const getAnalytictsPayload = (category, name, id, currencyFactor) => {
  let productDetails = {};
  let productList = [];
  productList = category?.products?.map(subItem => {
    subItem.items.forEach((element, index) => {
      let priceWithoutTaxObj = element.additionalProperties.find(
        item => item.key.toLowerCase() === MENU_PLP_CONSTANT.PRICE_WITHOUT_TAX.toLowerCase(),
      );
      let numricPrice = getPriceWithoutTax(priceWithoutTaxObj.value, currencyFactor).toFixed(2);
      numricPrice = numricPrice ? parseFloat(numricPrice) : 'NA';

      productDetails = {
        item_name: element.name,
        item_id: element.id,
        price: numricPrice,
        item_category: name,
        item_list_name: name,
        item_list_id: id,
        index: index,
        quantity: '1',
        currency: ANALYTICS_SHARED_CONSTANTS.INR,
      };
    });
    return productDetails;
  });
  return productList;
};

export const vieItemListAnalytics = async productList => {
  await AnalyticsService.registerEvent(
    events.viewItemListPlp.name,
    {
      data: {
        event: 'view_item_list',
        ecommerce: {
          // item_list: {
          items: productList,
          // },
        },
      },
    },
    getDataLayer,
  );
};

export const getCategoryFromSubCategory = (menu, activeMenuSelection) => {
  let selectedSubcategory = {};
  let selectedCategory = menu.find(item => item.name.trim() === activeMenuSelection) || {};
  if (Object.keys(selectedCategory).length === 0) {
    selectedCategory = menu.find(item => {
      if (item.categories?.length > 0) {
        for (const key in item.categories) {
          if (item.categories[key].id === activeMenuSelection) {
            selectedSubcategory = item.categories[key];
            return true;
          }
        }
      }
      return false;
    });
  }
  return { selectedCategory, selectedSubcategory };
};

export const getCategory = (categories, categoryUrl, setParamValue, setCategoryStatus, isMobile = false) => {
  console.log('PLP: categories: ', JSON.stringify(categories));
  if (isEmpty(categories)) {
    setCategoryStatus(false);
    return false;
  }

  const matchedCategory = categories?.find(({ url, isHidden: isHiddenCat, categories: subCategories }) => {
    let category = !isHiddenCat && url?.toLowerCase() === categoryUrl?.toLowerCase();
    if (!category) {
      category = subCategories.find(({ url, isHidden: isHiddenSubcat }) => {
        return !isHiddenSubcat && url?.toLowerCase() === categoryUrl?.toLowerCase();
      });
    }
    return category;
  });

  if (!isEmpty(matchedCategory)) {
    scroller.scrollTo(matchedCategory.name.trim(), {
      duration: 1500,
      delay: 100,
      smooth: false,
      containerId: '',
      offset: isMobile ? -150 : -100,
    });
  } else {
    if (categoryUrl) {
      setParamValue('category');
      setCategoryStatus(true);
    }
    if (!isEmpty(categories)) {
      const firstNonHiddenCategory = categories?.find(({ isHidden }) => !isHidden);
      firstNonHiddenCategory &&
        scroller.scrollTo(firstNonHiddenCategory.name.trim(), {
          duration: 1500,
          delay: 100,
          smooth: false,
          containerId: '',
          offset: isMobile ? -140 : -100,
        });
    }
  }

  return !isEmpty(matchedCategory);
};

export const shouldDisableButton = data => {
  return data?.isStoreClosed;
};

export const menuCardBtnTextForFavAndRecommendedMenu = data => {
  const { ADD_TO_CART_OCCASSION, STORE_CLOSED_BUTTON_TEXT } = ORDER_HISTORY;
  let btnText = translateWithI18Next(ADD_TO_CART_OCCASSION);
  let storeClosedBtnText = translateWithI18Next(STORE_CLOSED_BUTTON_TEXT);

  if (data?.isStoreClosed) {
    btnText = storeClosedBtnText;
  }

  return {
    btnText,
  };
};

export const menusPlpItemAnalyticFn = (suggestedData, inputSearchValue) => {
  if (suggestedData.length === 0) {
    getEmbeddedErrorMessageAnalytic(
      document.title,
      translateWithI18Next(YOUR_SEARCH_TEXT) + ` “${inputSearchValue}” ` + translateWithI18Next(TURNED_NO_RESULTS_TEXT),
    );
  }
};

export const modgrpsDetails = item => {
  const modgroups = item?.modgrpIds || [];
  let modifiersArray = [];
  modgroups?.forEach(modifier => {
    const { modifiers = [] } = modifier;
    modifiersArray.push(modifiers?.[0]?.name);
  });
  return modifiersArray;
};

export const OnSerchElmnt = params => {
  const {
    searchMode,
    filterList,
    dietaryList,
    products,
    viewUp,
    tenantData,
    getCardCount,
    catalogs,
    storeClosedData,
    setShowTopScrollBtn,
    searchModeElmnt,
    MenuItemList,
    CATEGORY_ID,
  } = params;
  if ((searchMode.isSearchedMode || [...filterList, ...dietaryList].length) && products?.length) {
    return (
      <div className={viewUp ? 'small-menu-container' : 'medium-menu-container'}>
        <MenuItemList
          productList={products}
          cardType={viewUp ? 'small' : 'medium'}
          tenantData={tenantData}
          cardCount={getCardCount}
          catalogs={catalogs}
          storeClosedData={storeClosedData}
          setShowTopScrollBtn={setShowTopScrollBtn}
          categoryId={CATEGORY_ID}
        />
      </div>
    );
  } else {
    return searchMode.isSearchedMode && searchModeElmnt();
  }
};
